// extracted by mini-css-extract-plugin
export default {"lockIcon":"styles_lockIcon__eDgQZ"};